import React from 'react'
import PropTypes from 'prop-types'
import { getNotificationContent } from '../content'
import { relativeTimeParts } from '../relativeTime'
import { propertyNavRoutes } from '../../Property/NavigationSidebar/NavigationHelper'

const LowResolutionImagesDetail = ({ notification, onReviewImages, t }) => {
  const { title, body } = getNotificationContent(notification, t)
  const time = relativeTimeParts(notification.createdAt)
  // edit-rooms when only room-gallery images are affected, otherwise images.
  const target = notification.payload?.target ?? propertyNavRoutes.images

  return (
    <React.Fragment>
      <div className="NotificationDetail-Category NotificationDetail-Category--warning">
        {t('notificationCenter.types.lowResolutionImages.category')}
      </div>
      <div className="NotificationDetail-Summary">
        <p className="NotificationDetail-Summary-Title">{title}</p>
        <p className="NotificationDetail-Summary-Time">{t(time.key, time.options)}</p>
      </div>
      {body && <p className="NotificationDetail-Description">{body}</p>}
      <button type="button" className="NotificationDetail-ReviewButton" onClick={() => onReviewImages(target)}>
        {t('notificationCenter.types.lowResolutionImages.reviewAction')}
      </button>
    </React.Fragment>
  )
}

LowResolutionImagesDetail.propTypes = {
  notification: PropTypes.object.isRequired,
  onReviewImages: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
}

export default LowResolutionImagesDetail
